/**
 * Determines whether or not 2 things are identically the same.
 */
export function is<T>(value: unknown, comparator: T): value is T {
  return value === comparator;
}

/**
 * Type guard that returns true if value is not null and not undefined.
 */
export function isNotNil<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}
